import { Navigate, Outlet, useLocation } from "react-router-dom";
import { useAppSelector } from "../../store/hooks";
import { LoadingState } from "../ui";

/**
 * Route guard for every authenticated page. While MSAL is still initialising it shows
 * a loader; once initialised it renders the protected routes when signed in, or
 * redirects to /account preserving the target so login returns here. Centralising this
 * keeps the pages themselves free of auth/redirect boilerplate.
 */
export default function RequireAuth() {
  const msalInitialized = useAppSelector((s) => s.auth.msalInitialized);
  const isAuthenticated = useAppSelector((s) => s.auth.isAuthenticated);
  const location = useLocation();

  if (!msalInitialized) return <LoadingState h={240} />;

  if (!isAuthenticated) {
    const redirect = encodeURIComponent(location.pathname + location.search);
    return <Navigate to={`/account?redirect=${redirect}`} replace />;
  }

  return <Outlet />;
}
